export default __webpack_public_path__ + "static/media/gallery_03.d67dc818.jpg";